import { INCHES_TO_CM_CONVERSION } from "constants/unit-conversions.constant";

export const convertInchesToCm = (inches: number): number => {
  return parseFloat((inches * INCHES_TO_CM_CONVERSION).toFixed(2));
};

export const convertCmToInches = (cm: number): number => {
  return parseFloat((cm / INCHES_TO_CM_CONVERSION).toFixed(2));
};
